module.exports = __webpack_public_path__ + "728fd219af713f367b10c1fef541fafa.svg";